import { useCallback } from 'react';

import { formatReferenceViewID, isIDSubject } from '../../modules/referenceView/index.ts';
import { setActiveID, setProperties } from '../../redux/features/referenceBarUISlice.ts';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.ts';
import { Tkv2ReferenceBarProperty } from '../types.ts';
import { useActiveReferenceBarID } from './useActiveReferenceBarID.ts';
import { selectReferenceBarUI } from '../../redux/features/selectors/referenceBarUISelectors.ts';
import { isRecommendedCompID } from '../../modules/referenceView/referenceViewID/isRecommendedCompID.ts';

// FIXME: move this out of the controller, perhaps with the reference bar component
export const useTkv2UpdateReferenceBarProperties = (): ((
  property: Tkv2ReferenceBarProperty,
) => void) => {
  const activeID = useActiveReferenceBarID();
  const dispatch = useAppDispatch();
    const { properties } = useAppSelector(selectReferenceBarUI);

  return useCallback(
    ({ id, mapPinLabel }: Tkv2ReferenceBarProperty) => {
      const isIDUnchanged = id && id === activeID;
      if (isIDUnchanged) {
        return;
      }

      dispatch(setActiveID(id ?? formatReferenceViewID({ type: 'subject' })));
      if (id && !isIDSubject(id) && isRecommendedCompID(id) && !properties.find((prop) => prop.id === id)) {
        dispatch(setProperties([...properties.filter((p) => !p.id.includes('tkl:')), { id, mapPinLabel }]));
      }

    },
    [activeID, dispatch, properties],
  );
};
